<!-- 平台过期弹窗 -->
<template>
  <el-dialog width="520px" custom-class="dialog_center" :visible.sync="dialogVisible" @close="hide">
    <div slot="title" class="dialog_title center">{{$ts('账户续费提示')}}</div>
    <div class="dialog_scroll platExpire_content">
      <div class="platExpire_tip">{{$ts('尊敬的用户您好')}}：</div>
      <div class="platExpire_text">
        {{$ts('贵单位账号的服务年费将于{days}天后到期({time})，为不影响正常业务经营及服务，请尽快完成续费，您可以线下联系销售经理处理，或售后服务群中反馈，如您已续费请忽略。',{
          days: days,
          time: expire_time
        })}}
      </div>
    </div>
    <div slot="footer" class="dialog_footer">
      <el-checkbox class="platExpire_checkbox" v-model="checked">{{$ts('我知道了')}}</el-checkbox>
      <el-button type="danger" @click="dialogVisible = false">{{$ts('关闭')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'plat-expire',
    data() {
      return {
        dialogVisible: false, //弹框
        checked: false,
        days: '',
        expire_time: '',
        platExpireData: {
          alert: false,
          date: ''
        }
      }
    },
    methods: {
      /* 显示弹框 */
      show(data) {
        this.days = data.days;
        this.expire_time = data.expire_time
        this.platExpireData = data.platExpireData;
        this.dialogVisible = true;
      },
      hide() {
        if (!this.dialogVisible) {
          this.platExpireData.alert = !this.checked;
          this.setLocalStorage('platExpire', this.platExpireData);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .platExpire {
    &_content {
      font-size: 14px;
      color: #666;
      line-height: 28px;
    }

    &_text {
      &::before {
        content: "";
        display: inline-block;
        width: 40px;
        height: 1px;
      }
    }

    &_checkbox {
      position: absolute;
      left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/plat-expire.vue